import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { RoomChat } from "@/components/RoomChat";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Navigate } from "react-router-dom";
import { MessagesSquare } from "lucide-react";

export default function Messages() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [rooms, setRooms] = useState([]);
  const [active, setActive] = useState(location.state?.roomId || null);

  useEffect(() => {
    if (user) api.get("/rooms").then(({ data }) => {
      setRooms(data);
      if (!active && data.length) setActive(data[0].room_id);
    }).catch(() => {});
    // eslint-disable-next-line
  }, [user]);

  if (loading) return <div className="min-h-screen bg-[#0B0E14] text-slate-400 flex items-center justify-center">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="min-h-screen bg-[#0B0E14]">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-2xl font-extrabold tracking-tight text-white mb-6 flex items-center gap-2">
          <MessagesSquare className="h-6 w-6 text-amber-400" /> Deal Rooms
        </h1>
        {rooms.length === 0 ? (
          <div className="text-center py-24 text-slate-500">
            No conversations yet. Open a deal and hit "Message the owner" to negotiate.
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 h-[70vh]">
            <div className="rounded-xl bg-[#121721] border border-white/10 overflow-y-auto" data-testid="rooms-list">
              {rooms.map((r) => (
                <button
                  key={r.room_id}
                  data-testid={`room-${r.room_id}`}
                  onClick={() => setActive(r.room_id)}
                  className={`w-full text-left p-4 border-b border-white/5 hover:bg-white/5 transition-colors ${
                    active === r.room_id ? "bg-white/5" : ""
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-white text-sm truncate">{r.counterpart}</span>
                    <span className="text-[10px] uppercase text-slate-600">{r.role}</span>
                  </div>
                  <div className="text-xs text-slate-500 truncate">{r.deal_title}</div>
                  {r.last_message && <div className="text-xs text-slate-600 truncate mt-1">{r.last_message}</div>}
                </button>
              ))}
            </div>
            <div className="lg:col-span-2 rounded-xl bg-[#121721] border border-white/10 overflow-hidden">
              {active ? <RoomChat roomId={active} /> : <div className="flex items-center justify-center h-full text-slate-500">Select a conversation</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
